module.exports = __webpack_public_path__ + "img/manajemen_login_&_perangkat.81bf4143.svg";